/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { ContentAiListContentQueryResponse, ContentAiListContentQueryParams, ContentAiListContent401, ContentAiListContent403 } from "../models/ContentAiListContent";

export function getContentAiListContentUrl() {
  const res = { method: 'GET', url: `/content-ai/v1/contents` as const }
  return res
}

/**
 * @summary List contents
 * {@link /content-ai/v1/contents}
 */
export async function contentAiListContent(params?: ContentAiListContentQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ContentAiListContentQueryResponse, ResponseErrorConfig<ContentAiListContent401 | ContentAiListContent403>, unknown>({ method : "GET", url : getContentAiListContentUrl().url.toString(), params, ... requestConfig })
  return res.data
}